import Vue, { PluginObject } from "vue";

class PermissionsPlugin implements PluginObject<any> {
    install = (_Vue: typeof Vue, options?: any) => {
        _Vue.prototype.$check = function (requiredPermissions: string[]): boolean {
            let user = this.$root.user.data || this.$root.user;
            
            if (!requiredPermissions || !requiredPermissions.length) return true;

            if (!user || !user.role || !user.role.permissions) {
                console.warn("Usuário ou permissões não definidas:", requiredPermissions);
                return false;
            }


            const userPermissions = user.role.permissions.map((item: any) => item.permission.key);

            if (userPermissions.includes("*")) return true;

            const hasPermission = requiredPermissions.some((permission) => {
                if (permission.endsWith(".view.amount")) {
                    return userPermissions.includes(permission);
                }

                return (
                    userPermissions.includes(permission) ||
                    userPermissions.includes(permission + ".*") ||
                    userPermissions.includes(permission.split(".")[0] + ".*")
                );
            });

            return hasPermission
        };
    };

    [key: string]: any;
}

const plugin = new PermissionsPlugin();
Vue.use(plugin);
